import { render } from "./CountrySavePage.vue?vue&type=template&id=28d4fcab"
import script from "./CountrySavePage.vue?vue&type=script&lang=js"
export * from "./CountrySavePage.vue?vue&type=script&lang=js"
script.render = render

export default script